import { useQuery } from "@tanstack/react-query"
import { isValid } from "date-fns"
import { useMemo } from "react"

import scheduleApi from "./scheduleApi"

const useMaintenanceQuery = () => {
  const { data: result } = useQuery(["scheduleApi.maintenance"], scheduleApi.maintenance)

  const dates = useMemo(() => {
    if (result?.isSuccess) {
      const [start, end] = result.data

      if (start && end && isValid(start) && isValid(end)) {
        return [start, end] as const
      }
    }

    return [null, null] as const
  }, [result])

  return dates
}

export default useMaintenanceQuery
